"use client";

import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="en">
      <body className="min-h-screen flex items-center justify-center bg-white text-slate-900">
        <div className="text-center px-6">
          <h1 className="text-xl font-semibold">Something went wrong</h1>
          <p className="mt-2 text-slate-600">
            An unexpected error occurred. Please refresh and try again.
          </p>
        </div>
      </body>
    </html>
  );
}
